import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: string;
  /** O'ng tomondagi amallar (tugma, filtr va h.k.). */
  actions?: ReactNode;
  className?: string;
}

/** Har bir ekranning yuqori qismi — bir xil balandlik va bir xil ritm. */
export const PageHeader = ({ title, description, actions, className }: PageHeaderProps) => (
  <div
    className={cn(
      "flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-4",
      className,
    )}
  >
    <div className="min-w-0">
      <h1 className="font-heading text-foreground text-2xl font-bold tracking-tight">{title}</h1>
      {description && <p className="text-muted-foreground mt-1 text-sm">{description}</p>}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
